import { Toaster as SonnerToaster, toast } from 'sonner';

import { useTheme } from '@/shared/hooks/use-theme';

/**
 * App-wide toast host. Positioned at the top on mobile so it never collides
 * with the bottom navigation or a sticky pay button.
 */
export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      theme={resolvedTheme}
      dir="rtl"
      position="top-center"
      richColors
      closeButton
      duration={4500}
      toastOptions={{
        classNames: {
          toast: 'font-sans rounded-xl border-border shadow-overlay',
          title: 'text-sm font-semibold',
          description: 'text-xs leading-relaxed',
        },
      }}
    />
  );
}

export { toast };
